var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-file',{attrs:{"accept":".xls, .xlsx","browse-text":_vm.$t('btn.basic.browse'),"placeholder":_vm.placeholder == null ? 'Choose a file or drop it here...' : _vm.placeholder},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})
}
var staticRenderFns = []

export { render, staticRenderFns }